import { AbstractEnvironmentService, IGetEnvironment_WSQuery, GetEnvironment_WSDocument } from '@workbench-stack/core';
import { injectable, inject, postConstruct } from 'inversify';
import { ApolloClient } from 'apollo-client';
import { ClientTypes } from '@common-stack/client-core';

@injectable()
export class EnvironmentClientService extends AbstractEnvironmentService {

    constructor(
        @inject(ClientTypes.ApolloClient)
        private apollo: ApolloClient<any>,
    ) {
        super();
    }

    @postConstruct()
    public async extInitialize(): Promise<void> {
        const result = await this.apollo.query<IGetEnvironment_WSQuery>({
            query: GetEnvironment_WSDocument,
        });
        this._environment = result.data.getEnvironment;
    }
}
